"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentFormattedPrice = void 0;
var _presentationUtils = require("@ori/presentation-utils");
const getCurrentFormattedPrice = ({
  formattedPrice
}) => {
  const {
    currentPrice,
    priceAfterImmediateDiscount
  } = formattedPrice?.price ?? {};
  if (priceAfterImmediateDiscount && (0, _presentationUtils.parseNumberFromString)(priceAfterImmediateDiscount) > 0) {
    return priceAfterImmediateDiscount;
  }
  return currentPrice ?? '';
};
exports.getCurrentFormattedPrice = getCurrentFormattedPrice;
